export const getStaticUrl = name => 'https://upload.hyperchain.cn/images/' + name

export const getThemeUrl = name => 'https://cdn.yourtheme.cn/' + name
